import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin } from "lucide-react";
import api from "@/lib/api";
import Logo from "@/components/Logo";
import NewsletterSignup from "@/components/public/NewsletterSignup";

export default function Footer() {
  const [s, setS] = useState({});
  useEffect(() => {
    api.get("/settings").then(({ data }) => setS(data)).catch(() => {});
  }, []);

  return (
    <footer className="on-dark bg-[#32104F] text-[#FFF9F2]">
      <NewsletterSignup />
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-3 items-start">
        <div>
          <Logo variant="full" className="h-40 w-auto -ml-2" />
          <p className="mt-4 text-sm text-[#D8B9EA] max-w-xs leading-relaxed">
            {s.tagline || "Kunst & Poesie"} — Susanne Monika Gysin
          </p>
        </div>

        <div className="text-sm">
          <div className="text-xs uppercase tracking-[0.2em] text-[#F4C542] mb-5">Navigation</div>
          <ul className="space-y-3 text-[#FFF9F2]">
            <li><Link to="/galerie" className="hover:text-[#F4C542] transition-colors">Bilder</Link></li>
            <li><Link to="/gedichte" className="hover:text-[#F4C542] transition-colors">Gedichte</Link></li>
            <li><Link to="/ueber-mich" className="hover:text-[#F4C542] transition-colors">Über mich</Link></li>
            <li><Link to="/kontakt" className="hover:text-[#F4C542] transition-colors">Kontakt</Link></li>
          </ul>
        </div>

        <div className="text-sm">
          <div className="text-xs uppercase tracking-[0.2em] text-[#F4C542] mb-5">Rechtliches</div>
          <ul className="space-y-3 text-[#FFF9F2]">
            <li><Link to="/impressum" className="hover:text-[#F4C542] transition-colors">Impressum</Link></li>
            <li><Link to="/datenschutz" className="hover:text-[#F4C542] transition-colors">Datenschutz</Link></li>
          </ul>
          <div className="flex gap-4 mt-6">
            {s.instagram && (
              <a href={s.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="text-[#D8B9EA] hover:text-[#F4C542] transition-colors">
                <Instagram className="w-5 h-5" strokeWidth={1.5} />
              </a>
            )}
            {s.facebook && (
              <a href={s.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="text-[#D8B9EA] hover:text-[#F4C542] transition-colors">
                <Facebook className="w-5 h-5" strokeWidth={1.5} />
              </a>
            )}
            {s.linkedin && (
              <a href={s.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="text-[#D8B9EA] hover:text-[#F4C542] transition-colors">
                <Linkedin className="w-5 h-5" strokeWidth={1.5} />
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="border-t border-[#632A8E]/50 py-6 text-center text-xs text-[#D8B9EA]">
        © {new Date().getFullYear()} Susanne Monika Gysin · gysumo.ch · Konzeption &amp; Entwicklung:{" "}
        <a
          href="https://inderwildi.org"
          target="_blank"
          rel="noreferrer"
          data-testid="footer-credit-link"
          className="hover:text-[#F4C542] transition-colors underline underline-offset-2"
        >
          inderwildi.org
        </a>
      </div>
    </footer>
  );
}
